import { ChangeDetectionStrategy, Component, Input, EventEmitter, Output } from '@angular/core';
import { NewsAutomationAgentsCount, DashboardNewsAutomationsWeeklyArticlesCount } from 'src/app/shared/dto';
import { DataTableColumn } from 'src/app/shared/components';
import { FeatureFlagsEnum, ResultTabsetUrlsEnum } from 'src/app/shared/enums';
import moment from 'moment';

@Component({
    selector: 'app-news-card',
    templateUrl: './news-card.component.html',
    styleUrls: ['../../common-reporting-dashboard.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class NewsCardComponent {
    @Input() isLoading: boolean;
    @Input() set newsAutomationsAgents(value: NewsAutomationAgentsCount[]) {
        if (value) {
          this.innerNewsAutomationsAgentsData = value;
        }
      }

      get newsAutomationsAgents(): NewsAutomationAgentsCount[] {
        return this.innerNewsAutomationsAgentsData;
      }

      @Input() set allNewsData(value: DashboardNewsAutomationsWeeklyArticlesCount[]) {
        if (value) {
          this.innerAllNewsAutomationsWeeklyData = value;
          this.updateChartData();
        }
      }

      get allNewsData(): DashboardNewsAutomationsWeeklyArticlesCount[] {
        return this.innerAllNewsAutomationsWeeklyData;
      }

      @Input() set selectedNewsData(value: DashboardNewsAutomationsWeeklyArticlesCount[]) {
        if (value) {
          this.innerSelectedNewsAutomationsWeeklyData = value;
        }
      }

      get selectedNewsData(): DashboardNewsAutomationsWeeklyArticlesCount[] {
        return this.innerSelectedNewsAutomationsWeeklyData;
      }

      @Input() chartData: Record<string, number[]> | number[];
      @Input() chartDataLabels: string[];
      @Input() newsAutomationData: DashboardNewsAutomationsWeeklyArticlesCount[];
      @Output() agentSelectionChanged = new EventEmitter();
      @Output() userScopeChange = new EventEmitter<boolean>();

      columns: DataTableColumn[] = [
        {
          dataField: 'start_date',
          caption: 'Date',
          cellTemplate: 'dateTemplate',
          width: '85%',
          cellClasses: 'border-b-0 pb-1 px-4',
          headerCellClasses: 'py-1',
          dateFormat: 'MM/dd/yy'
        },
        {
          dataField: 'count',
          caption: 'Articles',
          cellTemplate: 'numberTemplate',
          width: '15%',
          cellClasses: 'border-b-0 pb-1 px-4 text-center pr-6',
          headerCellClasses: 'py-1',
        },
      ];

      isShowChart: boolean = true;
      selectedOption: NewsAutomationAgentsCount = null;
      selectedScope: 'all' | 'current' = 'all';

      readonly featureFlagsEnum = FeatureFlagsEnum;
      readonly resultTabsetUrlsEnum = ResultTabsetUrlsEnum;

      private innerNewsAutomationsAgentsData: NewsAutomationAgentsCount[];
      private innerAllNewsAutomationsWeeklyData: DashboardNewsAutomationsWeeklyArticlesCount[];
      private innerSelectedNewsAutomationsWeeklyData: DashboardNewsAutomationsWeeklyArticlesCount[];

      updateChartData(): void {
        this.chartData = this.innerAllNewsAutomationsWeeklyData?.map(
          (d) => d.count,
        );
        this.chartDataLabels = this.innerAllNewsAutomationsWeeklyData
          ?.map((d) => {
            return moment(d.start_date).format('MM/DD/YY');
          })
          .sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
          this.newsAutomationData = this.innerAllNewsAutomationsWeeklyData.map(
              (data: DashboardNewsAutomationsWeeklyArticlesCount) => ({ ...data, "start_date": moment(data.start_date, 'YYYY-MM-DD').format('MM/DD/YYYY').toString(), "end_date": moment(data.end_date, 'YYYY-MM-DD').format('MM/DD/YYYY').toString() })
          )
      }

    updateSelectedOption(value: NewsAutomationAgentsCount | null) {
        this.selectedOption = value;
        value === null || value === undefined ? this.updateChartData() : this.agentSelectionChanged.emit(value);
    }

    onUserScopeChange(value: 'all' | 'current'): void {
        this.selectedScope = value;
        const includeAllUsers = value === 'all';
        if (value === 'all') {
            this.selectedOption = null;
            this.agentSelectionChanged.emit(null);
        }
        this.userScopeChange.emit(includeAllUsers);
    }
}
